import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteConfirmModal = ({ projectName, isMultiple, count, onConfirm, onCancel }) => {
  return (
    <div className="fixed inset-0 z-[200] bg-background/80 backdrop-blur-sm flex items-center justify-center p-4 animate-fade-in">
      <div className="bg-card rounded-xl border border-border p-6 md:p-8 max-w-md w-full animate-scale-in">
        <div className="flex items-start gap-4 mb-6">
          <div className="w-12 h-12 rounded-full bg-destructive/10 flex items-center justify-center flex-shrink-0">
            <Icon name="AlertTriangle" size={24} className="text-destructive" />
          </div>
          <div>
            <h3 className="text-xl font-semibold text-foreground mb-2">
              {isMultiple ? 'Delete Multiple Projects' : 'Delete Project'}
            </h3>
            <p className="text-sm text-muted-foreground">
              {isMultiple 
                ? `Are you sure you want to delete ${count} selected projects? This action cannot be undone.`
                : `Are you sure you want to delete "${projectName}"? This action cannot be undone.`
              }
            </p>
          </div>
        </div>

        <div className="bg-destructive/5 border border-destructive/20 rounded-lg p-4 mb-6">
          <div className="flex items-start gap-2">
            <Icon name="Info" size={16} className="text-destructive flex-shrink-0 mt-0.5" />
            <div className="text-sm">
              <p className="font-medium text-destructive mb-1">This will permanently delete:</p>
              <ul className="list-disc list-inside text-muted-foreground space-y-1">
                <li>All project files and code</li>
                <li>Project metadata and history</li>
                <li>Generated ZIP packages</li>
                {isMultiple && <li>All associated project data</li>}
              </ul>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-3">
          <Button
            variant="outline"
            size="default"
            onClick={onCancel}
            className="flex-1"
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            size="default"
            iconName="Trash2"
            iconPosition="left"
            onClick={onConfirm}
            className="flex-1"
          >
            {isMultiple ? `Delete ${count} Projects` : 'Delete Project'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;